import { MainHeader, PageTitle } from '@/shared/ui'

/**
 * Виджет: Header каталога
 * 
 * Использует унифицированные компоненты MainHeader и PageTitle.
 */
export function CatalogHeader() {
  return (
    <>
      <MainHeader />
      <PageTitle 
        title="Каталог чая и посуды"
        subtitle="Откройте новые вкусы, стили и способы заваривания"
        className="mt-6"
      />
    </>
  )
}
